

<template>
  <div>
    <v-container>
      <div v-if="loading" class="text-xs-center mt-3">
        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
      </div>
      <div v-else>
        <div class="text-xs-right">
          <v-btn v-if="!isEdit" @click="editdata" small icon outline color="primary">
            <v-icon small>edit</v-icon>
          </v-btn>
        </div>
        <v-layout>
          <v-flex xs6 class="pr-1">
            <div class="mb-2">
              <label>Big bottles</label>
              <h5 v-if="!isEdit" class="ma-0">{{ sessionvalue.bigbottles | numberFormat }}</h5>
              <div v-else class="form-control">
                <input type="number" v-model="input.bigbottles" />
              </div>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-1">
            <div class="mb-2">
              <label>Small bottles</label>
              <h5 v-if="!isEdit" class="ma-0">{{ sessionvalue.smallbottles | numberFormat }}</h5>
              <div v-else class="form-control">
                <input type="number" v-model="input.smallbottles" />
              </div>
            </div>
          </v-flex>
        </v-layout>
        <div class="mb-2">
          <v-layout class="mt-4" v-if="!isEdit">
            <v-flex xs6>
              <div>SCG</div>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <h5 style="font-size: 18px" class="ma-0">{{ sessionvalue.scg | numberFormat }}</h5>
            </v-flex>
          </v-layout>
          <div v-else class="form-control">
            <label>SCG</label>
            <input type="number" v-model="input.scg" />
          </div>
        </div>
        <div class="mb-2">
          <v-layout v-if="!isEdit">
            <v-flex xs6>
              <div>Inter express</div>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <h5 style="font-size: 18px" class="ma-0">
                {{ sessionvalue.interexpress | numberFormat }}
              </h5>
            </v-flex>
          </v-layout>
          <div v-else class="form-control">
            <label>Inter express</label>
            <input type="number" v-model="input.interexpress" />
          </div>
        </div>
        <div class="mb-2">
          <v-layout v-if="!isEdit">
            <v-flex xs6>
              <div>Point</div>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <h5 style="font-size: 18px" class="ma-0">{{ sessionvalue.point | numberFormat }}</h5>
            </v-flex>
          </v-layout>
          <div v-else class="form-control">
            <label>Point</label>
            <input type="number" v-model="input.point" />
          </div>
        </div>
        <div v-if="isEdit" class="text-xs-center">
          <v-btn @click="cancelEdit" color="grey" outline>{{ $t('cancel') }}</v-btn>
          <v-btn :loading="saveloading" @click="saveData" color="primary" depressed>{{
            $t('save')
          }}</v-btn>
        </div>
      </div>
      <div v-if="history.length">
        <v-divider class="my-3"></v-divider>
        <h5 style="font-size: 1.4em">Edit History</h5>
        <v-card class="pa-2 mb-2" v-for="(item, index) in history" :key="index">
          <div class="small" style="font-size: small">
            {{ item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}
          </div>
          <v-divider class="my-1"></v-divider>
          <v-layout row wrap class="mb-0">
            <v-flex xs2>
              <div>
                <div class="caption text-xs-center">Big bottles</div>
                <div class="text-xs-center" style="font-weight: bold">{{ item.bigbottles }}</div>
              </div>
            </v-flex>
            <v-flex xs2>
              <div>
                <div class="caption text-xs-center">Small bottles</div>
                <div class="text-xs-center" style="font-weight: bold">{{ item.smallbottles }}</div>
              </div>
            </v-flex>
            <v-flex xs2>
              <div>
                <div class="caption text-xs-center">SCG</div>
                <div class="text-xs-center" style="font-weight: bold">{{ item.scg }}</div>
              </div>
            </v-flex>
            <v-flex xs2>
              <div>
                <div class="caption text-xs-center">Inter Express</div>
                <div class="text-xs-center" style="font-weight: bold">{{ item.interexpress }}</div>
              </div>
            </v-flex>
            <v-flex xs2>
              <div>
                <div class="caption text-xs-center">Point</div>
                <div class="text-xs-center" style="font-weight: bold">
                  {{ item.point ? item.point : '-' }}
                </div>
              </div>
            </v-flex>
            <v-flex xs2>
              <div>
                <div class="caption text-xs-center">Point EXP</div>
                <div class="text-xs-center" style="font-weight: bold; font-size: 11px">
                  {{ item.pointexpireat | DateFormat('DD/MM/YYYY HH:mm') }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: null,
    },
  },
  data() {
    return {
      historyloading: false,
      saveloading: false,
      sessionvalue: '',
      loading: false,
      isEdit: false,
      history: [],
      input: {
        bigbottles: 0,
        smallbottles: 0,
        scg: 0,
        interexpress: 0,
        point: 0,
      },
    }
  },
  async mounted() {
    await this.getUser()
    this.getHistory()
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  methods: {
    getHistory() {
      api.getnvbbquotahistory(
        { pageid: this.selectedBot.pageid, userid: this.value.userid },
        (error, response) => {
          if (response.responsecode == 200) {
            if (response.data) {
              this.history = response.data.map((el) => {
                return { ...JSON.parse(el.sessionvalue), timestamp: el.timestamp }
              })
            }
          }
        }
      )
    },
    cancelEdit() {
      this.isEdit = false
    },
    saveData() {
      this.saveloading = true
      var obj = {}
      for (var item in this.input) {
        obj[item] = parseFloat(this.input[item])
      }
      var data = {
        pageid: this.selectedBot.pageid,
        usersid: this.value.userid,
        sessionvalue: JSON.stringify(obj),
      }

      api.putusersessionvalue(data, (err, response) => {
        this.saveloading = false
        this.sessionvalue = { ...this.input }
        this.isEdit = false
      })
    },
    getUser() {
      return new Promise((resolve) => {
        this.loading = true
        var data = {
          pageid: this.selectedBot.pageid,
          userid: this.value.userid,
        }
        api.getUser(data, (err, response) => {
          if (response.responsecode == 200 && response.data) {
            try {
              this.sessionvalue = JSON.parse(response.data[0].sessionvalue)
            } catch (error) {
              this.sessionvalue = ''
            }
          }
          this.loading = false
          resolve()
        })
      })
    },
    editdata() {
      this.isEdit = true
      this.input = { ...this.sessionvalue }
    },
  },
  watch: {
    value: async function (newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        await vm.getUser()
        vm.history = []
        vm.getHistory()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/livechat/NvbbQouta.vue